import isEqual from 'lodash/isEqual';

export default {
  isDirty(state) {
    return !isEqual(state.draft, state.master);
  },

  isPublishable(state) {
    return 'isDraft' in state.master
      && 'published' in state.master;
  },

  isPublished(state, getters) {
    return getters.isPublishable && state.master.published;
  },

  hasScheduledPublication(state) {
    if (typeof state.draft.schedulePublish !== 'undefined') {
      return state.draft.schedulePublish != null;
    }
    return false;
  },

  hasUrlSelected(state) {
    return ('homeUrl' in state.draft ? !!state.draft.homeUrl : false);
  },

  publicUrl(state) {
    return state.master.publicUrl || false;
  },

  /**
   * If the entity is published, returns its public URL, if any. Otherwise, returns false.
   * @return {string|false}
   */
  publishedUrl(state, getters) {
    if ((getters.isPublishable && getters.isPublished)
      || !getters.isPublishable) {
      return getters.publicUrl;
    }
    return false;
  },

  previewUrl(state) {
    if (!state.draft) {
      return null;
    }
    return state.draft.previewUrl;
  },

  hasPreview(state, getters) {
    return !!getters.previewUrl;
  },

  advancedMode(state) { return state.advancedMode; },
};
